export default __webpack_public_path__ + "static/Lincoln-61ac3d8df848a53349e555c5827ae0a2.png";